import { render, staticRenderFns } from "./ParkingSpacesPage.vue?vue&type=template&id=a42f43ca&scoped=true"
import script from "./ParkingSpacesPage.vue?vue&type=script&lang=js"
export * from "./ParkingSpacesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42f43ca",
  null
  
)

export default component.exports